module.exports = __webpack_public_path__ + "static/img/09.a13188f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour5/09.jpg
// module id = RxQn
// module chunks = 0